import React, { useRef } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Heading,
  List,
  Link,
  LinkImage,
  BlockQuote,
  Autoformat,
  Image,
  ImageToolbar,
  ImageStyle,
  ImageResize,
  ImageInsert,
  ImageUpload,
  ImageCaption,
  AutoImage,
  FileRepository,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";
import { uploadImage } from "../../utils/uploadImage";
import "./CKEditorField.css";

class CloudinaryAdapter {
  constructor(loader) {
    this.loader = loader;
  }
  async upload() {
    const file = await this.loader.file;
    const url = await uploadImage(file);
    return { default: url };
  }
  abort() {}
}

function CloudinaryUploadPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) =>
    new CloudinaryAdapter(loader);
}

const CKEditorField = ({ value, onChange }) => {
  const initial = useRef(value || "");

  return (
    <div className="ck-field">
      <CKEditor
        editor={ClassicEditor}
        data={initial.current}
        onChange={(event, editor) => onChange(editor.getData())}
        config={{
          licenseKey: "GPL",
          plugins: [
            Essentials,
            Paragraph,
            Bold,
            Italic,
            Heading,
            List,
            Link,
            LinkImage,
            BlockQuote,
            Autoformat,
            Image,
            ImageToolbar,
            ImageStyle,
            ImageResize,
            ImageInsert,
            ImageUpload,
            ImageCaption,
            AutoImage,
            FileRepository,
          ],
          extraPlugins: [CloudinaryUploadPlugin],
          toolbar: [
            "undo",
            "redo",
            "|",
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "|",
            "bulletedList",
            "numberedList",
            "blockQuote",
            "|",
            "insertImage",
          ],
          heading: {
            options: [
              { model: "paragraph", title: "Paragraf", class: "ck-heading_paragraph" },
              { model: "heading2", view: "h2", title: "Başlık 2", class: "ck-heading_heading2" },
              { model: "heading3", view: "h3", title: "Başlık 3", class: "ck-heading_heading3" },
            ],
          },
          image: {
            toolbar: [
              "imageStyle:alignLeft",
              "imageStyle:alignCenter",
              "imageStyle:alignRight",
              "|",
              "resizeImage",
              "|",
              "imageTextAlternative",
            ],
            resizeUnit: "%",
          },
          link: {
            defaultProtocol: "https://",
          },
          placeholder: "Yazınızı buraya yazmaya başlayın…",
        }}
      />
    </div>
  );
};

export default CKEditorField;
